import { Plus } from "lucide-react";
import { cn } from "../../utils/tailwindUtils";
import { Button } from "./button";
import male from "../../assets/svg/Male.svg";
import { useNavigate } from "react-router-dom";

export const ContainerCard = ({ children }) => {
    return (
        <div className="p-2 dark:bg-gray-900 rounded-lg dark:shadow-md h-[calc(100vh-64px)] overflow-y-auto flex flex-col">
            {children}
        </div>
    );
}

export const ModuleTitleCard = ({
    Icon,
    title,
    subtitle,
    totalRecords,
    buttonEnable = false,
    setOpenDialog,
    buttonName = "Add New",
    iconVisibility=true
}) => {
    const navigate=useNavigate()
    return (
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mb-1 p-2 rounded-lg">
            {/* Left Section - Title and Info */}
            <div className="flex-1">
                <div className="flex items-center gap-3">
                    {iconVisibility?<Icon className="w-6 h-6 text-sidebar-primary flex-shrink-0" />:
                        <Button
                            variant="ghost"
                            size="sm"
                            onClick={()=>navigate(-1)}
                            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl transition-colors duration-200"
                        >
                            <Icon className="h-5 w-5 text-gray-600 dark:text-gray-400" />
                        </Button>}
                    <h1 className="text-lg font-semibold text-gray-900 dark:text-white truncate">
                        {title}
                        {totalRecords !== undefined && totalRecords !== null && (
                            <span className="text-muted-foreground font-normal ml-2">
                                ({totalRecords})
                            </span>
                        )}
                    </h1>
                </div>

            </div>

            {/* Right Section - Button */}
            {buttonEnable && (
                <Button
                    size="lg"
                    className={cn(
                        "bg-primary hover:bg-sidebar-primary",
                        "dark:bg-sidebar-primary dark:hover:bg-sidebar-primary/90",
                        "text-white transition-colors duration-200",
                        "shadow-sm hover:shadow-md",
                        "whitespace-nowrap"
                    )}
                    onClick={() => setOpenDialog?.(true)}
                    aria-label={`Add new ${title}`}
                >
                    <Plus className="w-4 h-4 mr-2" />
                    {buttonName}
                </Button>
            )}
        </div>
    );
};

// employee profile
export const EmployeeDetails = ({
    details,
    icon,
    isFromSubordinate,
    profileWrap,
    isFromInbox,
    is_active = true,
    size
}) => {
    const fullname = `${details?.title ? details.title : ""} ${details?.first_name ? details.first_name : ""} ${details?.last_name ? details.last_name : ""}`.trim();
    const profile = details?.profile ? details.profile : male;
    const designation = details?.designation_id?.designation_name ? details.designation_id.designation_name : "-";
    const employee_code = details?.id ? details.id : "";

    // Determine avatar size class based on props
    const getAvatarSizeClass = () => {
        if (isFromSubordinate) return "w-8 h-8";
        if (isFromInbox) return "w-10 h-10";
        return "w-10 h-10";
    };

    // Determine text size class based on props
    const getNameSizeClass = () => {
        if (isFromSubordinate) return "text-sm";
        if (isFromInbox) return "text-base";
        return "text-base";
    };

    const getDesignationSizeClass = () => {
        if (isFromSubordinate) return "text-xs";
        return "text-sm";
    };

    const maxLength = isFromSubordinate ? 12 : isFromInbox ? 15 : 20;

    return (
        <div className="flex items-center gap-2">
            {!profileWrap && (
                <img
                    src={profile}
                    alt={fullname}
                    className={`${getAvatarSizeClass()} rounded-full object-cover border border-gray-200 dark:border-gray-600`}
                />
            )}

            <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                    <div className="flex-1 min-w-0">
                        <p className={`
                            font-medium text-${size} text-gray-900 dark:text-gray-100 truncate
                            ${getNameSizeClass()}
                            ${!is_active ? 'text-gray-400 dark:text-gray-500' : ''}
                        `}>
                            {fullname.length > maxLength ? (
                                <span
                                    className="cursor-help border-b border-dotted border-gray-300 dark:border-gray-600"
                                    title={fullname}
                                >
                                    {fullname.slice(0, maxLength)}...
                                </span>
                            ) : fullname || "-"}
                        </p>
                    </div>

                    {icon && (
                        <div className="flex-shrink-0 text-gray-400 dark:text-gray-500">
                            {icon}
                        </div>
                    )}
                </div>

                <p className={`
                    text-gray-600 text-${size} dark:text-gray-400 mt-0.5 truncate
                    ${getDesignationSizeClass()}
                    ${!is_active ? 'text-gray-400 dark:text-gray-500' : ''}
                `}>
                    {designation.length > maxLength ? (
                        <span
                            className="cursor-help border-b border-dotted border-gray-300 dark:border-gray-600"
                            title={designation}
                        >
                            {designation.slice(0, maxLength)}...
                        </span>
                    ) : designation || "-"}

                    {employee_code && (
                        <>
                            <span className="text-gray-400 dark:text-gray-500 mx-1">|</span>
                            {employee_code.length > 10 ? (
                                <span
                                    className="cursor-help border-b border-dotted border-gray-300 dark:border-gray-600"
                                    title={employee_code}
                                >
                                    {employee_code.slice(0, 10)}...
                                </span>
                            ) : employee_code}
                        </>
                    )}
                </p>
            </div>
        </div>
    );
};